import Direction from '@/directions/Direction'
import KeyValuePair from '@/interfaces/KeyValuePair'
import { CustomLocation } from '@/models/CustomLocation'
import { GeoJSON } from 'geojson'

export default class GeoDirection implements Direction {
	public text!: string
	public color!: string
	public icon!: string
	public country!: string

	public geo!: GeoJSON.Point

	public getQueryParameters(index: number): Array<KeyValuePair> {
		return [
			{
				key: `locations[${index}][geo]`,
				value: GeoDirection.coordinatesToString(this.geo)
			},
			{
				key: `locations[${index}][country]`,
				value: this.country
			}
		]
	}

	public static coordinatesFromString(geojson: string): GeoJSON.Point {
		return {
			type: 'Point',
			coordinates: geojson.split(',') as unknown as Array<number>
		} as GeoJSON.Point
	}

	public static coordinatesToString(geojson: GeoJSON.Point): string {
		return `${geojson.coordinates[0]},${geojson.coordinates[1]}`
	}

	public static pointToString(geojson: GeoJSON.Point): string {
		return `POINT(${geojson.coordinates[0]} ${geojson.coordinates[1]})`
	}

	public static fromCustomLocation(location: CustomLocation): GeoDirection {
		const direction = new GeoDirection()
		direction.geo = location.geoCoordinates as GeoJSON.Point
		direction.country = location.getCountry().iso
		direction.text = location.city
		return direction
	}
}
